import * as S from './styles'

import { ContactProvi, DataProvi, AddressProvi } from '~/components/organisms'
import { Svg } from '~/components/atoms'
import { useContext } from 'react'
import { ParamsContext } from '~/contexts/ParamsContext'

interface IFooter {
  isInCheckout: boolean
}

const Footer = ({ isInCheckout }: IFooter) => {
  const { route, router } = useContext(ParamsContext)
  const paddingVariant = route === '/courses/[slug]' && !!router.query?.classes?.length
  const currentYear = new Date().getFullYear()

  return (
    <S.FooterContainer isVariant={paddingVariant} isInCheckout={isInCheckout}>
      <S.FooterContent>
        <Svg src="/assets/svg/logo-provipay.svg" alt="logo provipay" width={125} height={24} loading="lazy" />
        <DataProvi companyName={`© ${currentYear} Provi Soluções e Serviços Ltda`} cnpj="CNPJ 32.390.384/0001-92" />
        <AddressProvi companyAddress="Av. Dr. Cardoso de Melo, 1340 cj. 11" city="Vila Olímpia, São Paulo/SP" cep="04548-004" />
        <ContactProvi />
      </S.FooterContent>
    </S.FooterContainer>
  )
}

export default Footer
